export default __webpack_public_path__ + "static/media/favorite_empty.bfbd5446.png";